import { create } from 'zustand';
import { getState, useState } from '@/framework';
import type { IExportState, ILayerProps, StateType } from '@/version-types';

/** 状态 */
export interface IState {
    /** 原始图层信息 */
    originLayers: ILayerProps[] | null;
}

/** 动作 */
export interface IAction {
    init: (layers: ILayerProps[]) => void;
    destroy: () => void;
}

/** 存储类型 */
export interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState(): IState {
    return {
        originLayers: null,
    };
}

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        ...getInitialState(),

        init(layers) {
            set({
                originLayers: layers,
            });
        },
        destroy() {
            set(getInitialState());
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'fusion-image-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useFusionImageState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getFusionImageState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

export const watchFusionImageState = (identity: string, callback: (state: IStore) => void) => {
    return getState<ModuleType>(identity)[name].subscribe((state, preState) => {
        if (JSON.stringify(preState) !== JSON.stringify(state)) {
            callback(state);
        }
    });
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
